import { Button } from "GameObjects/UI/Button";
import * as Constants from "Data/Constants";
import * as HLF from "html-living-framework";
import * as Topics from "Data/Topics";
import * as SFX from "Data/SoundEffect";
import * as VO from "Data/VoiceOver";
import Settings from "Data/Settings";
import { Howler } from "howler";
import {MainMenuLayout} from "Layouts/MainMenuLayout";
import { AbstractGameState } from "./AbstractGameState";
import SettingsPopup from "Popups/SettingsPopup";
import { Intro } from "./Intro";
import { Background } from "GameObjects/UI/Background";
import { LayoutSprite } from "GameObjects/UI/LayoutSprite";
import { FlyingGame } from "States/FlyingGame";
import { FreePlayMenu } from "States/FreePlayMenu";
import GameState from "Data/GameState";
import { LayoutButton } from "GameObjects/UI/LayoutButton";
import { Application } from "Application";

export class MainMenu extends AbstractGameState<typeof MainMenuLayout> implements ReturnType<typeof MainMenuLayout> {

    public static readonly NAME = "MainMenu";
    public readonly layout = MainMenuLayout;

    public readonly bg: LayoutSprite;
    public readonly logo: PIXI.Sprite;
    public readonly playButton: LayoutButton;
    public readonly freeplayButton: LayoutButton;

    protected readonly _bg = this.addChildAt(new Background(), 0);
    protected bgm = HLF.Application.instance.audio.getAudioTrack("flyingloop", HLF.AudioCategory.BGM) ?? HLF.Application.instance.audio.createAudioTrack("flyingloop", HLF.AudioCategory.BGM);

    public constructor() {
        super();
        this.bg = this._bg.addChild(new LayoutSprite());
        this.logo = this.addChild(new LayoutSprite());
        this.playButton = this.addChild(new LayoutButton(this.StartNewGame.bind(this), VO.MAIN_MENU_PLAY_HOVER, SFX.UI_CLICK));
        this.freeplayButton = this.addChild(new LayoutButton(()=>{
            Application.instance.analytics.event("select_content", "Training Mode");
            this.gotoNextState(FreePlayMenu.NAME);
        }, VO.MAIN_MENU_TRAINING_HOVER, SFX.UI_CLICK));
    }

    public init(pSize: PIXI.Point, pData: {name: string}) {
        super.init(pSize, pData);
        this.homeButton.visible = false;
        this.characterContainer.visible = false;
    }

    public animateIn(pOnComplete: ()=>void) {
        super.animateIn(pOnComplete);
        PubSub.publishSync(HLF.REGISTER_FOCUSABLES, [
            this.playButton,
            this.freeplayButton,
            this.helpButton,
            this.settingsButton,
            this.homeButton,
        ]);
        if (Settings.audioDescriptionEnabled) {
            HLF.Application.instance.voiceover.playVO(VO.MAIN_MENU_AUDIO_DESCRIPTION);
        }
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
    }

    protected StartNewGame() {
        GameState.flyingTimeElapsed = 0;
        GameState.freePlay = false;
        // reset badges
        GameState.dodgedAllObstacles = true;
        GameState.perfectPonds = true;
        GameState.swaptastic = true;
        this.gotoNextState(FlyingGame.NAME);
    }

    protected playHelpVO() {
        HLF.Application.instance.voiceover.playVO(VO.MAIN_MENU_HELP);
    }

}
